const namespace = 'APP_STATE/';

export const SET_STATE = namespace + 'SET_STATE';
export const RESET_N_FILTERS = namespace + 'RESET_N_FILTERS';
export const RESET_B_FILTERS = namespace + 'RESET_B_FILTERS';

export const SET_CODE_WORDS_VALIDATED = 'SET_CODE_WORDS_VALIDATED';